<!--基础课程预约-->

<template>
  <div class="app-container">
    <!-- <el-collapse v-model="activeNames"> -->

    <!-- <el-collapse-item name="1"> -->
    <!-- <template slot="title">
          <div class="title-container" shadow="never">
            <div class="title-con">
              <i class="el-icon-search"></i>
              <span style="margin-left: 5px;">筛选搜索</span>
            </div>
          </div>
        </template> -->
    <!--查询条件区域-->

    <!-- <el-card class="operate-container" shadow="never" style="margin-top: 0px;"> -->

    <div style="background: #FFFFFF;border-radius: 8px;padding: 24px 10px 2px 10px;text-align: left;">
      <el-form :inline="true" label-position="" :model="queryParam" label-width="90px">
        <!-- <el-row>
                <el-col :span="6">
                  <el-form-item label="课程名称:">
                    <el-input v-model="queryParam.lessonName" placeholder="输入课程名称"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="会员姓名:">
                    <el-input v-model="queryParam.userChildrenName" placeholder="输入姓名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="孩子小名:">
                    <el-input v-model="queryParam.userChildrenPetName" placeholder="输入小名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="日期:">
                    <el-date-picker
                      v-model="queryParam.day"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="卡号:">
                    <el-input v-model="queryParam.userPhone" placeholder="输入卡号"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-col :span="12">
                <el-form-item label="未来几天:">
                  <el-radio-group v-model="radio" @change="onChangeDay">
                <span v-for="(item,i) in redioWeek" :key="i" style="margin-right: 5px;">
                  <el-radio :label="i">{{item.weekDay}}</el-radio>
                </span>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="2"><div style="margin-top: 13px;font-size: 5px ;color: red">(点击立即查询)</div></el-col> -->
        <el-form-item label="未来几天:" label-width="80px">
          <div class="future">
            <div :class="pitchUp == index ? 'future-btn' : 'future-btm'" v-for="(v, index) in redioWeek" :key="index"
              @click="clcikPitchUp(index, v)">
              {{ v.weekDay }}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="会员手机号:">
          <el-input v-model="queryParam.userPhone" placeholder="请输入手机号" style="width: 125px;"></el-input>
        </el-form-item>
        <el-form-item label="会员名:" label-width="60px">
          <el-input v-model="queryParam.childName" placeholder="请输入姓名" style="width: 100px;"></el-input>
        </el-form-item>
        <el-form-item label="上课日期:" label-width="80px">
          <el-date-picker @change="clickChanges" v-model="queryParam.times" type="date" placeholder="选择日期"
            style="width: 140px;" value-format="yyyyMMdd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh"
            @click="handleResetSearch()">重 置</el-button>
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查
            询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <div class="button-container" style="margin-top: 0px">
            <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
          </div> -->
    <!-- </el-card> -->
    <!-- </el-collapse-item> -->


    <!-- </el-collapse> -->
    <!--    查询结果区域-->
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
        <span style="margin-left: 5px;color:black;">TOTAL:{{ totalChildren }}</span>
        <span style="margin-left: 5px;color:black;">NEW:{{ totalChildren2 }}</span>
      </div>
    </div>
    <!-- <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-edit" @click="borrow()">消费</el-button> -->
    <!-- <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-edit"
          @click="handleBatchChangeBook()">更改时间</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-folder-checked"
          @click="handleBatchSingIn()">签到</el-button>
        <el-button type="danger" size="medium" class="operator-btn3" style="margin-right: 0px;"
          icon="el-icon-circle-close" @click="handleBatchCancel()">取消</el-button>
        <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-circle-check"
          @click="handleExport()">导出</el-button>

      </div>
    </div> -->
    <div class="table-container" style="margin-top: 20px;">
      <div class="manage d-flex jc-end">
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="handleBatchSingIn()">签到</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="handleBatchChangeBook()">更改时间</el-button>
        <div class="spec-buton-box">
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="handleExport()">导出</el-button>
          <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
        </div>
        <div class="spec-buton-box">
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickManage(2)">跟进安排</el-button>
          <img class="spec-img" src="@/statics/imgs/svip.png" alt="" />
        </div>
        
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickManage(3)">取消</el-button>
        <div class="spec-buton-box">
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickManage(4)">参数设定</el-button>
          <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
        </div>
        
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickManage(5)">消费</el-button>
        <div class="spec-buton-box">
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickManage(6)">课评</el-button>
          <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
        </div>
        <div class="spec-buton-box">
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickManage(7)">多媒体</el-button>
          <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
        </div>
        
        
      </div>
      <el-table :data="tableData" :header-cell-style="{ 'text-align': 'center' }" :cell-style="cellStyle"
        ref="seleteTable" v-loading="listLoading" :span-method="objectSpanMethod" max-height="650" border
        style="width: 100%;font-size: 10px;font-weight: bold" @selection-change="handleSelectionChange">
        <!--<el-table-column prop="number" label="编号" width="100"></el-table-column>-->
        <!--<el-table-column prop="classDay" label="上课日期" width="100" ></el-table-column>-->
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="classTime" label="时间" width="70"></el-table-column>
        <el-table-column prop="lessonName" label="课程名" width="105"></el-table-column>
        <!-- <el-table-column prop="userPhoneNumber" label="会员手机号" show-overflow-tooltip="true" width="120"></el-table-column> -->
        <el-table-column prop="childName" label="会员名"  width="100"></el-table-column>
        <el-table-column prop="" label="会员手机号" width="125">
          <template slot-scope="scope">
            <div>
              <el-checkbox v-model="scope.row.checked" v-if="scope.row.userPhoneNumber">
              </el-checkbox>
              {{ scope.row.userPhoneNumber }}
            </div>
          </template>
        </el-table-column>

        <!--<el-table-column prop="teachersInfo" label="教练"  width="120"></el-table-column>-->
        <!-- <el-table-column prop="" label="卡号">
          <template slot-scope="scope">
            <div v-if="scope.row.userChildrenId != null">
              <el-checkbox v-show="scope.row.singIn != 1" v-model="scope.row.checked">
              </el-checkbox>
              {{ scope.row.userPhoneNumber }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="childName" label="会员姓名" width="110"></el-table-column> -->
        <el-table-column prop="childPetName" label="小名" width="70"></el-table-column>
        <el-table-column prop="monthCount" label="月龄" width="50"></el-table-column>
        <!-- <el-table-column prop="childType" label="婴儿类型" width="110"></el-table-column> -->
        <el-table-column prop="cardExperienceDisplay" label="卡种类" width="65"></el-table-column>
        <!-- <el-table-column prop="cardExperienceDisplay" label="卡号" show-overflow-tooltip="true"></el-table-column> -->
        
        <el-table-column label="签到状态" width="80">
          <template slot-scope="scope">
            <div style="background-color: green;color: white" v-if="scope.row.singIn == 1">
              已签到
            </div>
            <div style="color: #6c829a" v-if="scope.row.singIn == 0">
              未签到
            </div>
            <div style="background-color:  chartreuse; color: white" v-if="scope.row.singIn == 3">
              待审核
            </div>
          </template>

        </el-table-column>
        <el-table-column prop="singInTimeFormat" label="签到时间" show-overflow-tooltip="true" width="130">
        </el-table-column>
        <el-table-column prop="remainingClass" label="余量" width="60"></el-table-column>
        <el-table-column prop="baseSurplusHours" label="剩余课时阀值" show-overflow-tooltip="true" v-if="false"></el-table-column>

        <el-table-column label="课后服务" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.lessonEvaluationId == 1">课评</span>
            <span v-if="scope.row.multimediaId == 1">多媒体</span>
          </template>
        </el-table-column>
        <el-table-column prop="serviceWorker" label="服务老师" width="80"></el-table-column>
        <el-table-column prop="goodsName" label="消费" width="120"></el-table-column>
        <!--<el-table-column prop="cancelReason" label="取消原因" ></el-table-column>-->
        <el-table-column prop="bookRemark" label="备注" show-overflow-tooltip="true"></el-table-column>
        <!--<el-table-column prop="serviceWorker" label="服务人员" ></el-table-column>-->
        <!--<el-table-column prop="isServicedDes" label="是否服务过" ></el-table-column>-->
        <!--<el-table-column prop="goodsName" label="消费商品"   ></el-table-column>-->
        <!-- <el-table-column prop="goodsId" label="商品ID" v-if="false"></el-table-column> -->
        <!-- <el-table-column label="操作">
          <template slot-scope="scope">
            <div v-if="scope.row.bookStatu == 3">
              <el-dropdown size="mini" @command="handleCommand">
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown"> -->
        <!--审核-->
        <!-- <div v-if="scope.row.bookStatu == 3">
                    <el-dropdown-item
                      :command="beforeHandleCommand(scope.$index, scope.row, 'eSure')">确认</el-dropdown-item>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div> -->
        <!--消费商品-->
        <!-- <div v-if="scope.row.userPhoneNumber != null">
              <el-button @click="borrow(scope.row)" type="primary" size="small" plain>消费</el-button>
            </div>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <!--审核弹窗-->
    <el-dialog title="审核预约" :visible.sync="visibleDlgExamine" width="50%" center>
      <div>
        <el-form ref="registerRef" label-width="150px">
          <el-card style="margin-top: -20px;">
            <span>课程信息</span>
            <el-form-item label="课程名:">
              <el-input :readonly="true" style="width: 300px;" v-model="examineParam.lessonName"></el-input>
            </el-form-item>
          </el-card>
          <el-card style="margin-top: 10px;">
            <span>孩子信息</span>
            <el-form-item label="会员姓名:">
              <el-input :readonly="true" style="width: 300px;" v-model="examineParam.childName"></el-input>
            </el-form-item>
            <el-form-item label="孩子小名:">
              <el-input :readonly="true" style="width: 300px;" v-model="examineParam.childPetName"></el-input>
            </el-form-item>
            <el-form-item label="孩子课程等级:">
              <el-input :readonly="true" style="width: 300px;" v-model="examineParam.childLevel"></el-input>
            </el-form-item>
          </el-card>
          <el-card style="margin-top: 10px;">
            <span>家长信息</span>
            <el-form-item label="家长姓名:">
              <el-input readonly="true" style="width: 300px;" v-model="examineParam.userName"></el-input>
            </el-form-item>
            <el-form-item label="家长手机号:">
              <el-input readonly="true" style="width: 300px;" v-model="examineParam.userPhone"></el-input>
            </el-form-item>
          </el-card>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="handeleExamine(false)">不通过</el-button>
        <el-button type="success" @click="handeleExamine(true)">确认通过</el-button>
      </span>
    </el-dialog>
    <!--取消预约弹窗-->
    <el-dialog title="取消预约" :visible.sync="visibleCancel" width="50%" center>
      <el-form ref="registerRef" label-width="150px">
        <el-form-item label="取消原因:">
          <el-input readonly="true" style="width: 300px;" v-model="cancleBook.cancelReason"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="visibleCancel = false">取消</el-button>
        <el-button type="success" @click="handeleCancelBook">确认</el-button>
      </span>
    </el-dialog>
    <!--课后服务-->
    <el-dialog title="课后服务" :visible.sync="visibleAfterClassService" width="50%" center>
      <after-class-service :key="afterClassServiceDetailrefresh" @onBtnOK="onBtnOKSerivce"
        v-bind:detail="afterClassServiceDetail"></after-class-service>
    </el-dialog>
    <el-dialog title="课后服务详情" :visible.sync="visibleAfterClassServiceDetail" width="50%" center>
      <after-class-service :key="afterClassServiceDetailrefresh" @onBtnOK="onBtnOKSerivce"
        v-bind:detail="afterClassServiceDetail"></after-class-service>
    </el-dialog>
    <el-dialog title="选择课程" :visible.sync="visibleDlgSelectLesson" width="50%" center>
      <select-day-release-lesson ref="releaseLessonst" @onSelectLesson="onSelectLesson"></select-day-release-lesson>
    </el-dialog>

    <!--选择借用商品-->
    <el-dialog title="消费" :visible.sync="visibleSth" width="50%" center>
      <el-form ref="registerRef" label-width="150px">
        <el-form-item label="ID:" v-if="false">
          <el-input readonly="true" style="width: 300px;" v-model="updateParam.id"></el-input>
        </el-form-item>
        <el-form-item label="物品ID:" v-if="false">
          <el-input readonly="true" style="width: 300px;" v-model="updateParam.goodsId"></el-input>
        </el-form-item>
        <el-form-item label="卡号:" v-if="false">
          <el-input readonly="true" style="width: 300px;" v-model="updateParam.userBuyCardId"></el-input>
        </el-form-item>
        <el-form-item label="用户:" v-if="false">
          <el-input readonly="true" style="width: 300px;" v-model="updateParam.userId"></el-input>
        </el-form-item>
        <el-checkbox-group v-model="checkList">
          <el-checkbox v-for="filter in goodsList" :key="filter.value" :label="filter.value">{{ filter.text
          }}</el-checkbox>
        </el-checkbox-group>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="visibleSth = false">取消</el-button>
        <el-button type="success" @click="handleBorrowGoods">确认</el-button>
      </span>
    </el-dialog>


    <!-- 更改时间 -->
    <el-dialog title="更改时间" :visible.sync="dialogFormVisible" width="30%">
      <el-form :model="form" label-width="100px">
        <el-form-item label="手机号">
          <el-input v-model="form.name" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="会员姓名">
          <el-input v-model="form.region" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="小名">
          <el-input v-model="form.date" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="更改日期">
          <div style="display: flex;align-items: center;">
            <el-date-picker v-model="form.name" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
            </el-date-picker>
            <span style="margin: 0 5px;">至</span>
            <el-date-picker v-model="form.name" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="更改时间">
          <div style="display: flex;align-items: center;">
            <el-time-picker v-model="value1" :picker-options="{
              selectableRange: '18:30:00 - 20:30:00'
            }" placeholder="任意时间点">
            </el-time-picker>
            <span style="margin: 0 5px;">至</span>
            <el-time-picker arrow-control v-model="value2" :picker-options="{
              selectableRange: '18:30:00 - 20:30:00'
            }" placeholder="任意时间点">
            </el-time-picker>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button type="primary" @click="dialogForm(1)">保 存</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 跟进安排 -->
    <el-dialog title="跟进安排" :visible.sync="followUp" width="40%">
      <el-form :model="userForm" label-width="90px">
        <div style="display: flex;">
          <el-form-item label="手机号" prop="userPhoneNumber">
            <el-input disabled v-model="userForm.userPhoneNumber" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="生日">
            <el-input disabled v-model="userForm.userBirthday" autocomplete="off"></el-input>
          </el-form-item>
        </div>
        <div style="display: flex;">
          <el-form-item label="会员姓名" prop="childName">
            <el-input disabled v-model="userForm.childName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-input disabled v-model="userForm.gender" autocomplete="off"></el-input>
          </el-form-item>
        </div>
        <div style="display: flex;">
          <el-form-item label="小名">
            <el-input disabled v-model="userForm.childPetName" autocomplete="off"></el-input>
          </el-form-item>
        </div>
        <div style="display: flex;">
          <el-form-item label="跟进人">
            <div style="display: flex;flex-wrap: wrap;">
              <div style="display: flex;align-items: center;margin-bottom: 10px;" v-for="(v, index) in userForm.teaching" :key="index">
                <el-select v-model="v.assistant" placeholder="请选择" style="width: 240px" clearable="">
                  <el-option v-for="fk in selectAllList" :key="fk.id" :label="fk.name" :value="fk.id" :disabled="v.assistant == fk.id ||
                    userForm.teaching
                      .map((mk) => {
                        return Number(mk.assistant);
                      })
                      .includes(fk.id)
                    ? true
                    : false
                    ">
                  </el-option>
                </el-select>
                <img v-if="index == 0" src="../../statics/imgs/jh.png" alt=""
                  style="width: 25px;margin-left: 5px;height: 25px;margin-right: 10px;" @click="clickAddWordks">
                <img v-else src="../../statics/imgs/jih.png" @click="clickClearWorks(index)" alt=""
                  style="margin-right: 10px;width: 25px;margin-left: 5px;height: 25px;">
              </div>
            </div>
          </el-form-item>
        </div>

        <div style="display: flex;">
          <el-form-item label="跟进时间" prop="recordDateTime">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="userForm.recordDateTime" type="datetime"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item label="跟进内容">
          <el-input v-model="userForm.followContent" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button type="primary" @click="handleSubmit">保 存</el-button>
        <el-button @click="followUp = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 取消 -->
    <el-dialog title="取消" :visible.sync="abrogate" width="30%">
      <el-form :model="form" label-width="100px">
        <el-form-item label="会员名">
          <el-input v-model="batcheList.childName" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="会员手机号">
          <el-input v-model="batcheList.userPhoneNumber" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="课程名称">
          <el-input v-model="batcheList.name" autocomplete="off" disabled></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button type="primary" @click="batcheCancel">保 存</el-button>
        <el-button @click="abrogate = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 参数设定 -->
    <el-dialog title="参数设定" :visible.sync="Settings" width="50%">
      <div>
        <el-radio :disabled="disabledtd" v-model="radio" label="1">默认关闭</el-radio>
        <el-radio :disabled="disabledtd" v-model="radio" label="2">打开(需要购买权限)</el-radio>
      </div>
      <el-form :model="form" label-width="120px">
        <el-form-item label="小程序预约设置">
          <el-radio-group v-model="updateFrom.appointmentRule">
            <el-radio :label="false">关闭</el-radio>
            <el-radio :label="true">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <div style="display: flex;align-items: center;">
          <el-form-item label="开课前" style="width: 50%;">
            <div style="display: flex;">
              <el-input v-model="updateFrom.appointmentTime" autocomplete="off"
                style="width: 50%;margin-right: 20px;"></el-input>
              <span>小时内不可预约</span>
            </div>
          </el-form-item>
          <el-form-item label="开课前" style="width: 50%;">
            <div style="display: flex;">
              <el-input v-model="updateFrom.cancelTime" autocomplete="off"
                style="width: 50%;margin-right: 20px;"></el-input>
              <span>小时内不可取消</span>
            </div>
          </el-form-item>
        </div>
        <div style="display: flex;align-items: center;">
          <el-form-item label="开课前" style="width: 50%;">
            <div style="display: flex;">
              <el-input v-model="updateFrom.signBeforeTime" autocomplete="off"
                style="width: 50%;margin-right: 20px;"></el-input>
              <span>小时内签到</span>
            </div>
          </el-form-item>
          <el-form-item label="开课后" style="width: 50%;">
            <div style="display: flex;">
              <el-input v-model="updateFrom.signAfterTime" autocomplete="off"
                style="width: 50%;margin-right: 20px;"></el-input>
              <span>小时内签到</span>
            </div>
          </el-form-item>
        </div>
        <!-- <div style="display: flex;align-items: center;">
          <el-form-item label="未到签到" style="width: 50%;">
            <div style="display: flex;">
              <el-input v-model="updateFrom.notAttendSignDay" autocomplete="off"
                style="width: 50%;margin-right: 20px;"></el-input>
              <span>天内可预约</span>
            </div>
          </el-form-item>
        </div> -->
        <div style="display: flex;align-items: center;">
          <el-form-item label="剩余课时阈值" style="width: 50%;">
            <div style="display: flex;">
              <el-input v-model="updateFrom.baseSurplusHours" autocomplete="off"
                style="width: 50%;margin-right: 20px;"></el-input>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button type="primary" @click="dialogForm(4)">保 存</el-button>
        <el-button @click="Settings = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 消费 -->
    <el-dialog title="消费" :visible.sync="consumption" width="30%">
      <div>
        购买商品：
      </div>
      <div>
        <div style="display: flex;align-items: center;margin-top: 15px;" v-for="(v, index) in form" :key="index">
          <div style="margin-right: 15px;">
            <el-select v-model="v.goodsId" placeholder="下拉选择商品">
              <el-option v-for="item in searchList" :key="item.goodsId" :label="item.goodsName" :value="item.goodsId">
              </el-option>
            </el-select>
          </div>
          <div>
            <el-select v-model="v.payWay" placeholder="下拉选择付款方式">
              <el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <img v-if="index == 0" src="../../statics/imgs/jh.png" alt=""
            style="width: 25px;margin-left: 5px;height: 25px;margin-right: 10px;" @click="clickProduct">
          <img v-else src="../../statics/imgs/jih.png" @click="deleProduct(index)" alt=""
            style="margin-right: 10px;width: 25px;margin-left: 5px;height: 25px;">
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button type="primary" @click="borrows">保 存</el-button>
        <el-button @click="consumption = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 课评 -->
    <el-dialog :visible.sync="evaluation" title="课评" width="30%" center>
      <div class="overflow-hidden">
        <comment ref="commentRef" :courseRocordId="checkedId" :defaultConfig="defaultConfig"
          :swimInfoTable="swimInfoTable" :listtstt="getCheckedChild()" :commentID="2"></comment>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="buttonLoading" type="primary" @click="handleMaintainSubmit">提 交</el-button>
        <el-button @click="evaluation = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 课评 -->
    <!-- <el-dialog title="课评" :visible.sync="lessonEvaluation" width="30%">
      <el-form :model="form" label-width="100px">
        <el-form-item label="课程名">
          <el-input v-model="form.name" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="form.region" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="身高">
          <el-input v-model="form.date" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="体重">
          <el-input v-model="form.date" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="游泳时长">
          <el-input v-model="form.date" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="泳圈">
          <el-input v-model="form.date" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="其他内容">
          <el-input v-model="form.date" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="金币">
          <el-input v-model="form.date" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.date" autocomplete="off" disabled type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button type="primary" @click="dialogForm(6)">保 存</el-button>
        <el-button @click="lessonEvaluation = false">取 消</el-button>
      </div>
    </el-dialog> -->

    <!-- 多媒体上传 -->
    <el-dialog title="多媒体上传" :visible.sync="multimedia" width="30%" center>
      <div class="overflow-hidden">
        <multimediaVue ref="multimediaRef" :courseRocordId="checkedId" :defaultConfig="defaultConfig"
          :currentRow="getCheckedChild()[0]"></multimediaVue>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button type="primary" @click="handlMultimeSubmit(7)">保 存</el-button>
        <el-button @click="multimedia = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 课评口令 -->
    <worker-word
      :key="refreshWord"
      :word-type="wordType"
      :t-data="tData"
      :show="showWordDlg"
      @onWorkerWord="handleWord"
    ></worker-word>
  </div>
</template>


<script>
import commonUtils from "../../utils/commonUtils";
import globaldata from "../../utils/globaldata";
import multimediaVue from "./components/multimedia";
import {
  adminSign,
  batcheCancelBook,
  batcheChangeBook,
  batcheSingIn,
  fechListUserBookLesson,
  passbook,
  borrowGoods,
  searchGET,
  findTemplateById,
  borrowGoodsGET,
  updateTemplateSetting,
  selectAllGET,
  commitRecord
} from "../../api/userBookLesson";
import { getClassServiceAllItem, getClassServiceItem, qlSwCircle } from "../../api/StoreSetting";
import messageUtils from "../../utils/messageUtils";
import AfterClassService from "../my-store/component/AfterClassService";
import { setServiceTeacher, workerService, setBathWorker, updateCourseEval ,updateCourseMedia} from "../../api/AfterClassService";
import timeUtils from "../../utils/timeUtils";
import enumsUtil from "../../utils/enumsUtil";
import { fechListReleaseLessonDetail, lessonsGET } from "../../api/StoreReleaseLesson";
import { formatDate } from "../../utils/date";
import SelectDayReleaseLesson from "../components/SelectDayReleaseLesson";
import ExportJsonExcel from 'js-export-excel';
import { queryGoods } from "../../api/Goods";
import soundRecording from "@/components/soundRecording";
import comment from "../service/course-evaluation-A/components/comment.vue";
import WorkerWord from "@/components/WorkerWord/WorkerWord";
export default {
  components: { SelectDayReleaseLesson, AfterClassService, soundRecording, comment, multimediaVue,WorkerWord },
  data() {
    return {
      disabledtd:true,
      refreshWord: "",
      showWordDlg: false,
      tData: null,
      wordType: 0,
      evaluation: false, // 课评弹窗
      pitchUp: 0,
      radio: '1',
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }],
      selectAllList: [],
      value: '',
      value1: new Date(2016, 9, 10, 18, 40),
      value2: new Date(2016, 9, 10, 18, 40),
      form: {
        name: '',
        region: '',
        date: '',
      },
      checkedId: null, //选中的id
      defaultConfig: {},
      checkedData: {}, //选中的项
      swimInfoTable: [], //泳圈数据列表
      searchList: [],
      dialogFormVisible: false,//更改时间
      followUp: false, // 跟进安排
      abrogate: false, // 取消
      Settings: false, // 参数设定
      consumption: false, // 消费
      lessonEvaluation: false, // 课评
      multimedia: false, // 多媒体
      pitchList: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      totalChildren: 0,
      totalChildren2: 0,
      activeNames: ['1'],
      listLoading: true,
      storeLessonTemplateList: [],
      storeSwCircleList: [],
      storeWokers: [],
      buttonLoading: false,
      //弹窗
      visibleDlgAdd: false,
      visibleDlgExamine: false, //审核弹窗
      visibleCancel: false,     //取消预约
      visibleAfterClassService: false,     //课后服务

      visibleAfterClassServiceDetail: false,     //课后服务详情

      visibleDlgSelectLesson: false, //选择发布的课程
      AfterClassServiceType: 0,
      // radio: 0,
      redioWeek: [
        { day: 0, weekDay: '' },
        { day: 0, weekDay: '周三' },
        { day: 0, weekDay: '' },
        { day: 0, weekDay: '' },
        { ay: 0, weekDay: '' },
        { day: 0, weekDay: '' },
        { day: 0, weekDay: '' },
      ],
      redioDay: null,

      checkList: [],
      allGoodsList: [],
      //cities: cityOptions,
      goodsName: "",
      goodsList: [{
        value: "",
        text: "",
      }],
      batcheList: {
        childName: '', //会员名
        userPhoneNumber: '', //会员手机号
        name: '',
      },
      //查询参数
      queryParam: {
        userPhoneNumber: '',
        childName: '',
        times: '',
        days: '',
        lessonName: '',//课程名称
        userName: '',
        userPhone: '', //家长手机号
        userChildrenName: '',
        userChildrenPetName: '',
        userChildrenLevelDes: '',

        optionsSignStatuValue: "",

        optionsBookStatuValue: "",

        day: null,

        //分页查询
        pageNum: 1,//当前第几页
        totalPage: 1, //总共页数
        pageSize: 10,
        pageSizes: [20, 50, 100],
      },
      form: [{
        goodsId: '',
        payWay: ''
      }],
      userForm: {
        cardId: '',
        userId: '',
        userPhoneNumber: '',// 手机号
        childName: '', // 会员姓名
        childPetName: '', // 小名
        gender: '',//性别
        userBirthday: '',// 生日
        recordDateTime: '', //跟进时间
        followContent: '',//跟进内容
        teaching: [{
          assistant: ''
        }],
      },
      optionsSignStatu: [
        {
          value: null,
          label: "所有",
        },
        {
          value: 0,
          label: "未签到",
        },
        {
          value: 1,
          label: "已签到",
        }
      ],
      optionsBookStatu: [

        {
          value: 1,
          label: "预约成功",
        },
        // {
        //   value:2,
        //   label:"取消预约",
        // },
        {
          value: 3,
          label: "等待审核",
        },
        // {
        //   value:4,
        //   label:"已完成",
        // }
      ],
      redioWeek: [
        { day: 0, weekDay: '' },
        { day: 0, weekDay: '周三' },
        { day: 0, weekDay: '' },
        { day: 0, weekDay: '' },
        { ay: 0, weekDay: '' },
        { day: 0, weekDay: '' },
        { day: 0, weekDay: '' },
      ],
      //审核参数
      examineParam: {
        id: "",
        lessonName: '',//课程名称
        userName: '',
        userPhone: '', //家长手机号
        childName: '',
        childPetName: '',
        childLevel: 0,
        examineReason: ''
      },

      cancleBook: {


      },

      singInParam: {
        id: "",
      },

      updateParam: {
        id: "",
        storeFrontId: "",
        goodsId: "",
        checkList: "",
      },
      updateFrom: {},
      options: [{
        id: '1',
        label: '现金'
      }, {
        id: '2',
        label: '微信'
      }],
      //表单结果
      tableData: [
      ],
      spanArr: [],
      pos: 0,
      visibleSth: false,//借用物品弹出
      //添加参数
      createParam: {
        payTime: '',
        cardTime: '',
        storeLessonCardId: '1001',
        remark: '备注',// 剩余课时
        userPhone: '', //家长手机号
      },


      //课后服务参数
      afterClassServiceDetail: {},
      afterClassServiceDetailrefresh: "",

      curDay: "",//当前日期
      isVip: globaldata.getAdminStore().isVip,

    }
  },
  created() {
    globaldata.getStoreSwimCircle(this.getStoreSwimCircle);
    globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
    globaldata.getStoreGoods(this.getStoreGoods);
    this.getGoodsList();
    this.calRedioDay();
  },
  mounted() {
    this.qlSwCircle()

  },
  methods: {
    // 跟进安排 确认
    handleSubmit() {
      let param = {
        template: 2,
        publisher: globaldata.getAdminStore().id,
        type: 2,
        intentionLevel: 1,
        currentStage: 1,
        intentionLevel: 1,
        ...this.userForm
      }
      commitRecord(param).then((res) => {
        console.log(res, 'userForm=========')
        if (res.code == 20000) {
          this.$message.success("跟进安排成功");
          this.followUp = false;
          this.flechList();
        }
      })
      // this.$refs.userForm.validate((valid) => {
      //   if (valid) {
      //     alert('submit!');
      //   } else {
      //     console.log('error submit!!');
      //     return false;
      //   }
      // });
    },
    clickAddWordks() {
      let self = this;
      self.userForm.teaching.push({ assistant: "" });
    },
    clickClearWorks(index) {
      this.$delete(this.userForm.teaching, index);
    },
    //查询老师接口
    selectAll() {
      selectAllGET({ storeFrontId: globaldata.getAdminStore().storeFrontId }).then((res) => {
        if (res.code == 20000) {
          this.selectAllList = res.data
        }
      })
    },
    calRedioDay() {
      let nowDay = new Date();
      let dm = timeUtils.getDayMilSec();
      for (let i = 0; i < this.redioWeek.length; ++i) {
        let dayTime = nowDay.getTime() + (dm) * i;
        let date = new Date(dayTime);
        this.redioWeek[i].day = formatDate(date, 'yyyy-MM-dd');
        let weekDay = timeUtils.getWeekDay(date);
        this.redioWeek[i].weekDay = weekDay;
      }

    },
        // 多媒体弹窗提交按钮事件
    handlMultimeSubmit() {
      let self = this
      let listtst = this.getCheckedChild();
      let params = {
        identityId: listtst[0].userBookLessonId,
        video: self.$refs.multimediaRef.multimediaForm.video,
        image: self.$refs.multimediaRef.multimediaForm.image,
        audio:self.$refs.multimediaRef.audio,
        remark:self.$refs.multimediaRef.multimediaForm.remark

        // audio:self.$refs.multimediaRef.$refs.soundRecord.audio,
      };
      this.doRefreshWord(true, 2, params);
      return
      self.buttonLoading = true;
      updateCourseMedia(params)
        .then((response) => {
          if (response.code == 20000) {
            self.$message.success("提交成功");
            self.multimedia = false;
            self.checkedId = null
            self.$nextTick(()=>{
              self.$refs.multimediaRef.resetForm()

            })
            self.getList();
          }
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    // 取消确认
    batcheCancel() {
      let listtst = this.getCheckedChild();
      let params = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        adminId: globaldata.getAdminStore().id,
        adminWord: "",
        reaseon: "",
        items: [{
          id: listtst[0].userBookLessonId,
          childName: listtst[0].userId
        }]
      }
      batcheCancelBook(params).then((res) => {
        if (res.code == 20000) {
          messageUtils.successMsg(this, "取消成功")
          this.abolish = false
          this.flechList();
        }
      })
    },
    // 重置
    handleResetSearch() {
      this.queryParam = {
        lessonName: '',//课程名称
        userName: '',
        userPhone: '', //家长手机号
        userChildrenName: '',
        userChildrenPetName: '',
        userChildrenLevelDes: '',
        optionsSignStatuValue: "",
        optionsBookStatuValue: "",
        userPhoneNumber: '',
        childName: '',
        // dayTime:new Data(),
        day: null,
        days: '',
        times: '',
        //分页查询
        pageNum: 1,//当前第几页
        totalPage: 1, //总共页数
        pageSize: 10,
        pageSizes: [20, 50, 100],
      },
        this.pitchUp = 0
      this.flechList();
    },
    // 选中周几
    clcikPitchUp(index, v) {
      this.pitchUp = index
      this.queryParam.days = timeUtils.transDayInt(v.day)
      this.queryParam.times = ''
      this.flechList();

    },
    clickChanges() {
      this.queryParam.days = ''
      this.pitchUp = 0
    },
    // 弹窗打开
    clickManage(val) {
      let self = this
      switch (val) {
        case 1:
          this.dialogFormVisible = true
          break;
        case 2:
        if (this.isVip == 0 || this.isVip == 1) return this.$message.warning("该功能需要开通SVIP功能，请先开通相关权益！");
          let lis = this.getCheckedChild();
          if (lis && lis.length) {
            if (lis.length == 1) {
              self.selectAll()
              self.userForm.userId = lis[0].userId
              self.userForm.cardId = lis[0].userBuyCardId
              self.userForm.userPhoneNumber = lis[0].userPhoneNumber
              self.userForm.childName = lis[0].childName
              self.userForm.childPetName = lis[0].childPetName
              self.userForm.gender = lis[0].gender == 1 ? '男' : '女'
              self.userForm.userBirthday = lis[0].userBirthday
              self.followUp = true
            } else {
              self.$message.error('请选择一条数据');
            }
          } else {
            self.$message.error('请选择一条数据');
          }
          break;
        case 3:
          let listtst = this.getCheckedChild();
          console.log(listtst, 'listtst============')
          if (listtst && listtst.length) {
            if (listtst.length == 1) {
              self.batcheList.userPhoneNumber = listtst[0].userPhoneNumber
              self.batcheList.childName = listtst[0].childName
              self.batcheList.name = listtst[0].name
              self.abrogate = true
            } else {
              self.$message.error('请选择一条数据');
            }
          } else {
            self.$message.error('请选择一条数据');
          }
          break;
        case 4:
        if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
          this.findTemp()
          this.disabledtd = false
          this.Settings = true
          break;
        case 5:
          this.form = [{
            payWay: "",
            goodsId: "",
          }]
          let listt = this.getCheckedChild();
          this.searchG()
          if (listt && listt.length) {
            if (listt.length == 1) {
              self.consumption = true
            } else {
              self.$message.error('请选择一条数据');
            }
          } else {
            self.$message.error('请选择一条数据');
          }
          break;
        case 6:
        if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
          let listtstt = this.getCheckedChild();

          if (listtstt && listtstt.length) {
            if (listtstt.length == 1) {
              if (listtstt[0].singIn != 0) {
                this.checkedId = listtstt[0].storeLessonId;
                self.lessonsCopy() // 查询课程配置
                
              } else {
                self.$message.error('请选择已签到的学生');
              }
            } else {
              self.$message.error('请选择一条数据');
            }
          } else {
            self.$message.error('请选择一条数据');
          }
          break;
        case 7:
        if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
          let list = this.getCheckedChild();
          if (list && list.length) {
            if (list.length == 1) {
              this.checkedId = list[0].userBookLessonId;
              self.lessons() // 查询课程配置
              this.multimedia = true
              self.$nextTick(() => {
                self.$refs.multimediaRef.getFetch();
              });
            } else {
              self.$message.error('请选择一条数据');
            }
          } else {
            self.$message.error('请选择一条数据');
          }
          break;
      }
    },
    qlSwCircle() {
      // this.listLoading = true;

      let param = {
        // storeFrontId: 2201,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      };
      qlSwCircle(param).then((response) => {
        // this.listLoading = false;
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        this.swimInfoTable = date;
        console.log(this.swimInfoTable, ' this.swimInfoTable=======')

      });
    },
    //查询课程配置
    lessonsCopy() {
      let self = this;
      let listtst = this.getCheckedChild();
      lessonsGET({ id: listtst[0].storeLessonId }).then((res) => {
        if (res.code == 20000) {
          this.defaultConfig = res.data
          self.evaluation = true
          self.$nextTick(() => {
            self.$refs.commentRef.getFetch();
          });
          // this.dimensions = res.data.dimensions
          // this.dimensions.forEach((item)=>{

          // })
        }
      })
    },
    //查询课程配置
    lessons() {
      let listtst = this.getCheckedChild();
      lessonsGET({ id: listtst[0].storeLessonId }).then((res) => {
        if (res.code == 20000) {
          this.defaultConfig = res.data
          // this.dimensions = res.data.dimensions
          // this.dimensions.forEach((item)=>{

          // })
        }
      })
    },
    // 课评弹窗提交事件
    handleMaintainSubmit() {
      let comment = {};
      let listtst = this.getCheckedChild();
      if( this.$refs.commentRef.courseForm.dimensions &&  this.$refs.commentRef.courseForm.dimensions.length){
        this.$refs.commentRef.courseForm.dimensions.map((item) => {
        comment[item.field] = item.value;
      });
      }
      let params = {
        id: listtst[0].userBookLessonId,
        comment: JSON.stringify(comment),
        swimmingRings: this.$refs.commentRef.courseForm.swimmingRings,
        gold: this.$refs.commentRef.courseForm.gold
          ? Number(this.$refs.commentRef.courseForm.gold)
          : null,
        remark:this.$refs.commentRef.courseForm.remark
      };
      this.doRefreshWord(true, 1, params);
      return
      this.buttonLoading = true;
      updateCourseEval(params)
        .then((response) => {
          if (response.code == 20000) {
            this.$message.success("提交成功");
            this.evaluation = false;
            this.redioDay = null;
            this.flechList();
          }
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    handleWord(wordType, tData) {
      if (wordType == 1) {
        this.doBuyExpCard(tData);
      }else if(wordType == 2){
        this.doMultimeCourse(tData);
      }
    },
    doBuyExpCard(param) {
      updateCourseEval(param).then((response) => {
        this.closeWordDlg();
        if (response.code == 20000) {
          this.$message.success("提交成功");
          this.evaluation = false;
          this.redioDay = null;
          this.flechList();
        } else {
          messageUtils.errorMsg(this, response.message);
          this.initData();
        }
      });
    },
    doMultimeCourse(param) {
      let self = this;
      updateCourseMedia(param).then((response) => {
        this.closeWordDlg();
        if (response.code == 20000) {
          self.$message.success("提交成功");
          self.multimedia = false;
          self.checkedId = null
          self.$nextTick(()=>{
            self.$refs.multimediaRef.resetForm()

          })
          self.flechList();
        }
      });
    },
    doRefreshWord(show, wordType, tData) {
      this.tData = tData;
      this.wordType = wordType;

      this.showWordDlg = show;
      this.refreshWord = new Date().getTime();
    },
    closeWordDlg() {
      this.wordTitle = "";
      this.wordType = 0;
      this.showWordDlg = false;
      this.refreshWord = new Date().getTime();
    },
    // 消费 添加
    clickProduct() {
      this.form.push({
        payWay: "",
        goodsId: "",
      })
    },
    // 消费 删除
    deleProduct(index) {
      this.form.splice(index, 1)
    },
    //消费
    borrows() {
      let listt = this.getCheckedChild();
      let cardList = []
      let data = {
        cardId: listt[0].userBuyCardId,
        userId: listt[0].userId,
      }
      cardList.push(data);
      let param = {
        cardList: cardList,
        userBookLessonId: listt[0].userBookLessonId,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        goodsPayWays: this.form
      }
      console.log(param, 'user/lessons/borrowGoods')
      // return
      borrowGoodsGET(param).then((res) => {
        if (res.code == 20000) {
          messageUtils.successMsg(this, "批量消费成功")
          this.consumption = false
          this.flechList();
        }
      })
    },
    findTemp() {
      let params = {
        template: 2,
        id: globaldata.getAdminStore().storeFrontId
      }
      findTemplateById(params).then((res) => {
        console.log(res, '==============')
        if (res.code == 20000) {
          this.updateFrom = {
            ...res.data,
            appointmentRule:false
          }
        }
      })
    },
    // 弹窗关闭
    dialogForm(val) {
      switch (val) {
        case 1:
          this.dialogFormVisible = false
          break;
        case 2:
          this.followUp = false
          break;
        case 3:
          this.abrogate = false
          break;
        case 4:
          this.updateTempl()
          // this.Settings = false
          break;
        case 5:
          this.consumption = false
          break;
        case 6:
          this.lessonEvaluation = false
          break;
        case 7:
          this.multimedia = false
          break;
      }
    },
    updateTempl() {
      updateTemplateSetting({ ...this.updateFrom, shopFrontId: globaldata.getAdminStore().storeFrontId, template: 2 ,radio:this.radio}).then((res) => {
        if (res.code == 20000) {
          messageUtils.successMsg(this, "参数设定成功")
          this.Settings = false
          this.flechList();
        }
      })
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {

      //指定坐标rowIndex ：行，columnIndex ：列
      if (row.singIn == 1) {
        if (columnIndex == 7) {
          return 'background:green;text-align:center;color:white'
        }
      }
      if ((row.remainingClass < row.baseSurplusHours) && row.remainingClass > 0) {
        if (columnIndex == 7) {
          return 'text-align:center;color:white'
        }
      }
      if ((row.remainingClass < row.baseSurplusHours) && row.remainingClass > 0) {
        if (columnIndex == 9) {
          return 'background:#FAA0A0;text-align:center;color:white'
        }
      }
      return 'text-align:center' //rgb(105,0,7)
      
    },
    getStoreWorkersInfo(list) {
      this.storeWokers = list;
      globaldata.getStoreLessonTemplate(this.getStoreLessonTemplate);
      this.calRedioDay();
    },
    getStoreGoods(list) {
      this.allGoodsList = this.allGoodsList.concat(list.list);
    },
    //商品
    searchG() {
      searchGET({ shopFrontId: globaldata.getAdminStore().storeFrontId }).then((res) => {
        if (res.code == 20000) {
          this.searchList = res.data.list
        }
      })
    },
    getGoods(id) {
      for (let i = 0; i < this.allGoodsList.length; ++i) {
        if (this.allGoodsList[i].goodsId == id) {
          return this.allGoodsList[i].goodsName;
        }
      }
      return ""
    },
    getStoreLessonTemplate(list) {
      this.storeLessonTemplateList = list;
      this.flechList();
    },
    getStoreSwimCircle(list) {

      this.storeSwCircleList = list;
    },
    getStoreWorkersInfoById(id) {

      if (commonUtils.isObjectNull(id)) {
        return "";
      }
      for (let i = 0; i < this.storeWokers.length; ++i) {
        if (this.storeWokers[i].id == id) {
          return this.storeWokers[i];
        }
      }
      return null;
    },
    getStoreLessonTemplateById(id) {
      for (let i = 0; i < this.storeLessonTemplateList.length; ++i) {
        if (this.storeLessonTemplateList[i].id == id) {
          return this.storeLessonTemplateList[i];
        }
      }
      return null;
    },

    calRedioDay() {
      let nowDay = new Date();
      let dm = timeUtils.getDayMilSec();
      for (let i = 0; i < this.redioWeek.length; ++i) {
        let dayTime = nowDay.getTime() + (dm) * i;
        let date = new Date(dayTime);
        this.redioWeek[i].day = formatDate(date, 'yyyy-MM-dd');
        let weekDay = timeUtils.getWeekDay(date);
        this.redioWeek[i].weekDay = weekDay;
      }

    },
    onChangeDay(val) {
      let day = this.redioWeek[val].day;
      this.redioDay = day;
      this.fechListUserBookLesson(day);
    },
    fechListUserBookLesson(day) {

      this.listLoading = true;
      let now = new Date();
      day = formatDate(now, 'yyyy-MM-dd')
      timeUtils.transDayInt(day);

      let dayTime = this.queryParam.times ? this.queryParam.times : this.queryParam.days ? this.queryParam.days : timeUtils.transDayInt(day);
      // if (commonUtils.isObjectNull(day)) {

      //   this.curDay = day;
      // } else {
      //   // let nowStr= formatDate(day, 'yyyy-MM-dd')
      //   dayTime = timeUtils.transDayInt(day);
      //   this.curDay = day;
      // }
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        storeReleaseLessonId: this.queryParam.storeReleaseLessonId,
        userPhone: this.queryParam.userPhone,
        userPhoneNumber: this.queryParam.userPhoneNumber,
        childName: this.queryParam.childName,
        // childName: this.queryParam.userChildrenName,
        childPetName: this.queryParam.userChildrenPetName,
        bookStatu: this.queryParam.optionsBookStatuValue,
        singIn: this.queryParam.optionsSignStatuValue,
        lessonName: this.queryParam.lessonName,
        dayTime: dayTime,
        lessonTemplateId: enumsUtil.lessonTemplateIdBS(),
        pageNum: this.queryParam.pageNum,//当前第几页
        pageSize: this.queryParam.pageSize
      }

      const loading = this.myLoading();

      fechListReleaseLessonDetail(param).then(response => {
        loading.close();
        this.listLoading = false;
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        console.info(date);
        date.forEach(item => {
          if (item.goodsId != null) {
            let goods = item.goodsId;
            goods = goods.toString().split(",");
            let goodsName = "";
            for (var i = 0; i < goods.length; i++) {
              goodsName = goodsName + this.getGoods(goods[i]) + ",";
            }
            //console.info(goodsName);
            item.goodsName = goodsName.toString().replace(/^(\s|,)+|(\s|,)+$/g, '');
          }
        });
        // this.queryParam.totalPage = date.total;
        this.refreshData(date);

      })
    },

    flechList() {
      let day;
      // if (this.redioDay == null) {
      //   day = this.queryParam.day;
      // } else {
      //   day = this.redioDay;
      // }

      this.fechListUserBookLesson(day);
    },

    getoptionsSignStatu(value) {
      if (value == null) {
        return ""
      }
      for (let i = 0; i < this.optionsSignStatu.length; ++i) {
        if (value == this.optionsSignStatu[i].value) {
          return this.optionsSignStatu[i].label
        }
      }

    },

    getoptionsBookStatu(value) {
      if (value == null) {
        return ""
      }
      for (let i = 0; i < this.optionsBookStatu.length; ++i) {
        if (value == this.optionsBookStatu[i].value) {
          return this.optionsBookStatu[i].label
        }
      }
    },
    //刷新页面数据
    refreshData(list) {
      if (commonUtils.isObjectNull(list)) {
        return;
      }
      let totalNum = 0;
      let totalNum2 = 0
      this.spanArr = []
      let tableDataList = [];
      for (let i = 0; i < list.length; ++i) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0
        } else {
          // 判断当前元素与上一个元素是否相同  inAccessCode（批次字段）
          if (list[i].dayTime === list[i - 1].dayTime
            && list[i].classStartTime === list[i - 1].classStartTime
            && list[i].classEndTime === list[i - 1].classEndTime && list[i].name === list[i - 1].name) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
        // alert(JSON.stringify(this.spanArr))

        let childType = enumsUtil.childBodyType(list[i].childType);
        let classDay = timeUtils.transDay(list[i].dayTime)
        let data = {
          number: i + 1,
          id: list[i].id,
          userId: list[i].userId,
          gender: list[i].gender,
          userBirthday: list[i].userBirthday,
          userChildrenId: list[i].childId,
          userBuyCardId: list[i].buyCardId,
          storeReleaseLessonId: list[i].storeReleaseLessonId,
          classDay: classDay,
          classTime: timeUtils.transTimeHM(list[i].classStartTime) + " - " + timeUtils.transTimeHM(list[i].classEndTime),
          lessonName: list[i].name,
          userPhoneNumber: list[i].userPhoneNumber,
          childName: list[i].childName,
          childPetName: list[i].childPetName,
          monthCount: list[i].monthCount,
          childType: childType,
          childLevel: list[i].childLevel,
          singInTime: list[i].singInTime,
          singInTimeFormat: list[i].singInTimeFormat,
          singIn: list[i].singIn,
          singInDes: this.getoptionsSignStatu(list[i].singIn),
          bookStatu: list[i].bookStatu,
          bookStatuDes: this.getoptionsBookStatu(list[i].bookStatu),
          bookTime: list[i].bookTime,
          userBookLessonId: list[i].userBookLessonId,
          lessonTemplateId: list[i].lessonTemplateId,
          lessonTemplateType: this.getStoreLessonTemplateById(list[i].lessonTemplateId).type,
          cancelReason: list[i].cancelReason,
          bookRemark: list[i].bookRemark,
          afterClassService: list[i].afterClassService,
          name: list[i].name,
          storeLessonId: list[i].storeLessonId,
          teachersInfo: list[i].teachersInfo,
          serviceWorker: this.getStoreWorkersInfoById(list[i].serviceTeacher).name,
          checked: false,
          goodsId: list[i].goodsId,
          goodsName: list[i].goodsName,
          remainingClass: list[i].remainingClass,
          baseSurplusHours: list[i].baseSurplusHours,
          multimediaId: list[i].multimediaId,
          lessonEvaluationId: list[i].lessonEvaluationId,
          cardExperienceDisplay: list[i].cardExperienceDisplay,
        };
        if (list[i].userPhoneNumber != null && list[i].userPhoneNumber != '') {
          totalNum = totalNum + 1
        }
        if (list[i].userPhoneNumber != null && list[i].userPhoneNumber != '' && list[i].cardExperience != 0) {
          totalNum2 = totalNum2 + 1
        }
        tableDataList.push(data);
      }
      this.totalChildren = totalNum
      this.totalChildren2 = totalNum2
      this.tableData = tableDataList;
      console.log(this.spanArr,this.tableData,'this.spanArr============')

    },

    //点击查询按钮
    onBtnSearch() {
      this.redioDay = null;
      this.flechList();
    },
    handleSelectionChange(val) {

    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {

      //如果上课日期和上下课时间相同,并且名字相同，需要合并  columnIndex 需要合并的列
      if (columnIndex === 0 || columnIndex === 1) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },


    handleCurrentChange(val) {
      this.queryParam.pageNum = val;
      this.flechList();
    },
    handleSizeChange(val) {
      this.queryParam.pageSize = val;
      this.flechList();
    },

    beforeHandleCommand(index, row, command) {
      return {
        'index': index,
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      switch (command.command) {
        case "eSure"://
          this.showVisibleDlgExamine(command.index, command.row);
          break;
        case "sign"://签到
          this.showVisableSignDlg(command.index, command.row);
          break;
        case "afterClass"://课后服务
          this.showDlgafterClassService(command.row);
          break;
        case "cancelBook"://取消预约
          this.showCancelBookDlg(command.row);
          break;
        case "serviceDetial"://服务详情
          this.showDlgafterClassServiceDetail(command.row);
          break;

      }
    },

    showDlgafterClassService(row) {
      this.showDlgService(row, 1);
      this.visibleAfterClassService = true;
    },
    showDlgafterClassServiceDetail(row) {
      this.showDlgService(row, 2);
      this.visibleAfterClassServiceDetail = true;
    },

    /**
     *
     * @param type 1 表示 服务  2 表示查看服务详情
     */
    showDlgService(row, type) {
      let swCircle = [];
      for (let i = 0; i < this.storeSwCircleList.length; ++i) {
        if (this.storeSwCircleList[i].statu == 0) {
          swCircle.push(this.storeSwCircleList[i].name);
        }
      }
      if (row.isServiced) {
        let serviceDetail = JSON.parse(row.afterClassService)
        this.afterClassServiceDetail = {
          type: type,
          userBookLessonId: row.id,
          lessonName: row.lessonName,
          childName: row.childName,
          lessonTemplateId: row.lessonTemplateId,
          swCircle: swCircle,
          height: serviceDetail.height,
          weight: serviceDetail.weight,
          temperature: serviceDetail.temperature,
          swCircle: serviceDetail.swCircle,
          evaluate: serviceDetail.evaluate
        }
      } else {
        this.afterClassServiceDetail = {
          type: type,
          userBookLessonId: row.id,
          lessonName: row.lessonName,
          childName: row.childName,
          lessonTemplateId: row.lessonTemplateId,
          swCircle: swCircle,
        }
      }

      this.AfterClassServiceType = type;
      this.afterClassServiceDetailrefresh = new Date().getTime();
    },

    onBtnOKSerivce() {
      this.visibleAfterClassService = false;
    },


    //添加一个
    handleCreateOne() {
      this.visibleDlgAdd = true;
    },

    handeleExamine(val) {
      //通过审核
      let param = {
        adminId: globaldata.getAdminStore().id,
        id: this.examineParam.id
      }
      if (val == true) {
        passbook(param).then(response => {
          let date = response.data;
          if (commonUtils.isObjectNull(date)) {
            return;
          }
          messageUtils.successMsg(this, response.message);
          this.visibleDlgExamine = false;
        })
      } else {
        this.visibleDlgExamine = false;
      }
    },

    showVisibleDlgExamine(index, row) {
      this.examineParam = {
        id: row.id,
        lessonName: row.lessonName,
        userName: row.userName,
        userPhone: row.userPhone,
        childName: row.childName,
        childPetName: row.childPetName,
        childLevel: row.childLevel,
        examineStatu: row.examineStatu,
        examineReason: ""
      }
      this.visibleDlgExamine = true;
    },

    showVisableSignDlg(index, tableData) {
      this.examineParam = {
        id: tableData.id,
      }
      this.$confirm('确认签到?', '温馨提示', {
        confirmButtonText: '确定签到',
        cancelButtonText: '取消',
        type: 'success ',
        center: true
      }).then(() => {
        this.handeleSign()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消签到'
        });
      });
    },

    handeleSign() {
      let param = {
        adminId: globaldata.getAdminStore().id,
        id: this.examineParam.id
      }
      adminSign(param).then(response => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        messageUtils.successMsg(this, response.message);
        this.flechList();
      })
    },

    showCancelBookDlg(row) {
      this.cancleBook = {
        id: row.id,
        cancelReason: "",
      }
      this.visibleCancel = true;
    },
    handeleCancelBook() {
      let param = {
        adminId: globaldata.getAdminStore().id,
        id: this.cancleBook.id,
        reason: this.cancleBook.cancelReason,
      }
      adminSign(param).then(response => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        messageUtils.successMsg(this, response.message);
        this.flechList();
      })
    },
    //批量取消
    handleBatchCancel() {
      let list = this.getCheckedChild();
      if (list.length <= 0) {
        messageUtils.errorMsg(this, "请勾选会员");
        return;
      }


      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        adminId: globaldata.getAdminStore().id,
        adminWord: "",
        reaseon: "",
        items: [],
      }
      for (let i = 0; i < list.length; ++i) {
        let item = {
          id: list[i].userBookLessonId,
          childName: list[i].childName,
        }
        param.items.push(item);
      }
      const loading = this.myLoading("取消预约中,请稍后!!1");
      batcheCancelBook(param).then(response => {
        loading.close();
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data.success == true) {
          messageUtils.successMsg(this, data.message);
          this.flechList();
        } else {
          messageUtils.errorMsg(this, data.message);
        }
      })

    },
    //批量签到
    handleBatchSingIn() {
      let list = this.getCheckedChild();
      if (list.length <= 0) {
        messageUtils.errorMsg(this, "请勾选会员");
        return;
      }

      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        adminId: globaldata.getAdminStore().id,
        adminWord: "",
        items: [],
      }
      for (let i = 0; i < list.length; ++i) {
        let item = {
          id: list[i].userBookLessonId,
          childName: list[i].childName,
        }
        param.items.push(item);
      }
      const loading = this.myLoading("签到中,请稍后!!1");
      batcheSingIn(param).then(response => {
        loading.close();
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data.success == true) {
          messageUtils.successMsg(this, data.message);
          this.flechList();
        } else {
          messageUtils.errorMsg(this, data.message);
        }

      })
    },

    //批量更改预约
    handleBatchChangeBook() {
      let list = this.getCheckedChild();
      if (list.length <= 0) {
        messageUtils.errorMsg(this, "请勾选会员");
        return;
      }
      if (list[0].singIn != 0) {
        messageUtils.errorMsg(this, "未签到才能更改时间");
        return;
      }
      this.visibleDlgSelectLesson = true;
      this.$nextTick(() => {
        this.$refs['releaseLessonst'].templates = 2
        // console.log(this.$refs.releaseLessonst,"this.$refs['releaseLesson']======'")
      })
    },



    //获取选中的会员
    getCheckedChild() {
      let list = [];
      for (let i = 0; i < this.tableData.length; ++i) {
        if (this.tableData[i].checked == true) {
          list.push(this.tableData[i]);
        }
      }
      return list;
    },
    onSelectLesson(releaseLesson) {

      this.visibleDlgSelectLesson = false;
      let list = this.getCheckedChild();
      this.doBatchChangeBook(list, releaseLesson);

    },
    doBatchChangeBook(list, releaseLesson) {
      if (commonUtils.isObjectNull(releaseLesson)) {
        return;
      }
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        adminId: globaldata.getAdminStore().id,
        adminWord: "",
        remark: "",
        releaseLessonId: releaseLesson.id,
        items: [],
      }

      for (let i = 0; i < list.length; ++i) {
        let item = {

          oldBookId: list[i].userBookLessonId,
          userId: list[i].userId,
          childId: list[i].userChildrenId,
        }
        param.items.push(item);
      }
      const loading = this.myLoading();
      batcheChangeBook(param).then(response => {
        loading.close();
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data.success == true) {
          messageUtils.successMsg(this, data.message);
          this.flechList();
        } else {
          messageUtils.errorMsg(this, data.message);
        }

      })
    },

    /**
     * 导出按钮事件
     */
    handleExport() {
      if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
      const data = this.tableData;//表格数据
      let nowStr = formatDate(new Date(), "yyyy-MM-dd hh.mm.ss")
      var option = {};
      let dataTable = [];
      if (data) {
        for (let i in data) {
          if (data) {

            let obj = {
              '课程ID': data[i].id,
              '上课时间': data[i].classTime,
              '课程名': data[i].lessonName,
              '教练': data[i].teachersInfo,
              '卡号': data[i].userPhoneNumber,
              '会员姓名': data[i].childName,
              '小名': data[i].childPetName,
              '月龄': data[i].monthCount,
              '婴儿类型': data[i].childType,
              '预约备注': data[i].bookRemark,
            }
            dataTable.push(obj);
          }
        }
      }
      option.fileName = '基础游预约表_' + nowStr;
      option.datas = [
        {
          sheetData: dataTable,
          sheetName: this.curDay,
          sheetFilter: ['课程ID', '上课时间', '课程名', '教练', '卡号', '会员姓名', '小名', '月龄', '婴儿类型', '预约备注'],
          sheetHeader: ['课程ID', '上课时间', '课程名', '教练', '卡号', '会员姓名', '小名', '月龄', '婴儿类型', '预约备注'],
        }
      ];
      var toExcel = new ExportJsonExcel(
        option,

      );
      toExcel.saveExcel();
      toExcel.close();
    },

    //消费商品
    // borrow(){
    //   let list = this.getCheckedChild();
    //   if (list.length <=0){
    //     messageUtils.errorMsg(this,"请勾选会员");
    //     return;
    //   }
    //   this.visibleSth = true;
    // },
    borrow(row) {
      // let list = this.getCheckedChild();
      // if (list.length <=0){
      //   messageUtils.errorMsg(this,"请勾选会员");
      //   return;
      // }
      this.visibleSth = true;
      this.updateParam.userBuyCardId = row.userBuyCardId;
      this.updateParam.userId = row.userId;
    },
    /**
     * 消费商品提交
     */
    handleBorrowGoods() {
      let list = this.getCheckedChild();
      this.visibleSth = false
      let cardList = []
      // for (let i =0;i<list.length;++i ){
      //   let data = {
      //     cardId:list[i].userBuyCardId,
      //     userId:list[i].userId,
      //   }
      //   cardList.push(data);
      // }
      let data = {
        cardId: this.updateParam.userBuyCardId,
        userId: this.updateParam.userId,
      }
      cardList.push(data);
      let param = {
        cardList: cardList,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        goodsId: this.checkList.toString(),
      }
      this.checkList = []
      borrowGoods(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data.success == true) {
          messageUtils.successMsg(this, data.message);
          this.flechList();
        } else {
          messageUtils.errorMsg(this, data.message);
        }
      })
    },

    getGoodsList() {
      let param = {
        shopFrontId: globaldata.getAdminStore().storeFrontId,
      }
      //alert(param.shopFrontId);
      queryGoods(param).then(response => {
        this.listLoading = false;
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        this.totalPage = data.total;
        //console.info(data.list);
        for (var i = 0; i < data.list.length; i++) {
          //console.log(data.list[i])
          let good = {
            value: "", text: "",
          };
          good.value = data.list[i].goodsId;
          good.text = data.list[i].goodsName;
          this.goodsList[i] = good;
        }
        //console.info(this.goodsList);
      })
    },

  }
}
</script>


<style scoped>
.future {
  background: #ECF3FD;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 5px;
}

.manage {
  background-color: #fff;
  padding: 20px;
  text-align: right;
}

.future-btn {
  width: 100px;
  height: 40px;
  background: #0E6FB8;
  border-radius: 8px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  text-align: center;
}

.future-btm {
  width: 100px;
  height: 40px;
  background: #ECF3FD;
  border-radius: 8px;
  font-size: 14px;
  color: #74798C;
  cursor: pointer;
  text-align: center;
}

.el-form-item {
  text-align: left;
}

.table-container {
  border: 0px;
}

.overflow-hidden {
  height: 540px;
  overflow-x: hidden;
}

/deep/ .el-table th.el-table__cell>.cell {
  /* width: 90%; */
  /* height: auto; */
  background: #ecf3fd;
  /* border-radius: 8px; */
}

/deep/ .el-table__header-wrapper .cell {
  line-height: 60px;
  color: #0d6fb8;
}

/deep/ .el-dialog--center {
  /* border: 2px solid #d0d0d0; */
  border-radius: 10px;
}

/deep/ .el-dialog__header {
  text-align: left;
  /* border-radius: 10px;
  background: #f0f7ff; */
}
/deep/ .el-table .cell {
  font-size: 14px !important;
}

/deep/ .el-form--inline .el-form-item {
  margin-right: 5px;
}

/deep/ .el-table .el-table__cell {
  padding: 0px;
}

/deep/ .el-table--enable-row-transition .el-table__body td.el-table__cell {
  padding: 3px 0;
}
</style>




// WEBPACK FOOTER //
// src/views/user-book-lesson/UserBookLessonBs.vue